// // STAGE URL
// const AUTH_BASE = "http://doodlebluelive.com:2369/api/v1";
// const PRODUCT_BASE = "http://doodlebluelive.com:2370/api/v1";

// PRODUCTION URL
const AUTH_BASE = "https://backend2.thetwicetreasured.com/api/v1";
const PRODUCT_BASE = "https://product.thetwicetreasured.com/api/v1";

export const endpoints = {
  auth: {
    LOGIN: `${AUTH_BASE}/user/signInAdmin`,
    ADD_STAFF: `${AUTH_BASE}/user/staff/create`,
    EDIT_STAFF: `${AUTH_BASE}/user/edit/staff`,
    GET_STAFF_BY_ID: `${AUTH_BASE}/user/staff`,
    GET_STAFF: `${AUTH_BASE}/user/all/staff?limit=10`,
    DELETE_STAFF: `${AUTH_BASE}/user/delete/staff`,
    ADD_ROLE: `${AUTH_BASE}/user/createrole`,
    EDIT_ROLE: `${AUTH_BASE}/user/edit/role`,
    GET_ROLE: `${AUTH_BASE}/user/all/role?limit=10`,
    GET_ROLE_BY_ID: `${AUTH_BASE}/user/role`,
    DELETE_ROLE: `${AUTH_BASE}/user/delete/role`,
    GET_ROLE_DROPDOWN: `${AUTH_BASE}/user/all/role/dropdown`,
    UPDATE_PROFILE: `${AUTH_BASE}/user/edit/profile`,
    GET_PROFILE: `${AUTH_BASE}/user/getProfile`,
    CHANGE_PASSWORD: `${AUTH_BASE}/user/changepassword/profile`,
    RESET_PASSWORD: `${AUTH_BASE}/user/admin/forgot/password`,
    // FORGOT_PASSWORD: `${AUTH_BASE}/user/admin/forgot/password/verify `,
  },
  product: {
    ADD_PRODUCT: `${PRODUCT_BASE}/products/addProduct`,
    GET_ALL_DONATION: `${PRODUCT_BASE}/products/allDonation?limit=10`,
    GET_DONATION_BY_ID: `${PRODUCT_BASE}/products/oneDonation`,
    DELETE_DONATION: `${PRODUCT_BASE}/products/delete/donation`,
    UPDATE_DONATION: `${PRODUCT_BASE}/products/update/donation`,
    GET_ALL_INVENTORY: `${PRODUCT_BASE}/products/allProducts?role=admin&limit=10`,
    DELETE_INVENTORY: `${PRODUCT_BASE}/products/delete/inventory`,
    GET_INVENTORY_BY_ID: `${PRODUCT_BASE}/products/oneInventory`,
    UPDATE_INVENTORY: `${PRODUCT_BASE}/products/update/inventory`,
    UPDATE_IMAGE: `${PRODUCT_BASE}/seller/update/productImage`,
  },
  directory: {
    ADD_INFLUENCER: `${PRODUCT_BASE}/influencer/addInfluencer`,
    GET_ALL_INFLUENCER: `${PRODUCT_BASE}/influencer/get/influencerAll?limit=10`,
    DELETE_INFLUENCER: `${PRODUCT_BASE}/influencer/delete/influencer`,
    UPDATE_INFLUENCER: `${PRODUCT_BASE}/influencer/update/influencer`,
    GET_ALL_BUYER: `${AUTH_BASE}/userTransaction/directory/buyer?limit=10`,
    UPDATE_BUYER: `${AUTH_BASE}/userTransaction/directory/buyer/update`,
    GET_ALL_SELLER: `${AUTH_BASE}/userTransaction/directory/seller?limit=10`,
    UPDATE_SELLER: `${AUTH_BASE}/userTransaction/directory/seller/update`,
  },
  disputed: {
    GET_ALL_DISPUTED: `${PRODUCT_BASE}/dispute/admin/getAllDispute?limit=10`,
    UPDATE_DISPUTED: `${PRODUCT_BASE}/dispute/admin/updateDisputeDetails`,
    GET_DISPUTED_BY_ID: `${PRODUCT_BASE}/dispute/admin/getDisputeByid`,
    DELETE_DISPUTED_BY_ID: `${PRODUCT_BASE}/dispute/admin/deleteDisputeById`,
    ADD_DISPUTED: `${PRODUCT_BASE}/dispute/admin/addDisputeDetails`,
    CREATE_NEW_PAYMENT: `${PRODUCT_BASE}/dispute/payment/create`,
    DISPUTE_HISTORY: `${AUTH_BASE}/payment/dispute/listDisputePaymentDetails`,
  },
  dashboard: {
    GET_STATISTICS: `${PRODUCT_BASE}/products/dashboard/numbers`,
    GET_CURRENT_INVENTORY: `${PRODUCT_BASE}/products/dashboard/current/inventory`,
    GET_CATEGORY_STATS: `${PRODUCT_BASE}/products/dashboard/category/inventory`,
    GET_REVENUE: `${AUTH_BASE}/userTransaction/dashboard/revenue`,
    GET_INVENTORY_FLOW: `${PRODUCT_BASE}/products/dashboard/inventory/flow`,
  },
  transaction: {
    GET_ALL_TRANSACTION: `${AUTH_BASE}/userTransaction/getAll?limit=10`,
  },
  notification: {
    GET_ALL_NOTIFICATION: `${AUTH_BASE}/notification/get/notification?limit=10`,
    REMOVE_NOTIFICATION: `${AUTH_BASE}/notification/update`,
  },
  common: {
    GET_ALL_CATEGORY: `${PRODUCT_BASE}/category/getallcategorylist`,
    SINGLE_FILE_UPLOAD: `${PRODUCT_BASE}/upload/single`,
    MULTIPLE_FILE_UPLOAD: `${PRODUCT_BASE}/upload/uploadFile`,
    DONATION_DROPDOWN: `${PRODUCT_BASE}/products/donation/status/dropdown`,
    INVENTORY_DROPDOWN: `${PRODUCT_BASE}/products/inventory/status/dropdown`,
    VALIDATE_TOKEN: `${AUTH_BASE}`,
    ACTIONLIST: `${AUTH_BASE}/user/getActionslist`,
  },
  payments: {
    GET_ALL_SELLER: `${PRODUCT_BASE}/seller/admin/getAllSeller`,
    GET_SELLER_BY_ID: `${PRODUCT_BASE}/seller/admin/getSellerByid`,
    DELETE_SELLER_BY_ID: `${PRODUCT_BASE}/seller/admin/deleteSellerById`,
    ADD_NEW_SELLER: `${PRODUCT_BASE}/seller/admin/addSellerDetails`,
    CREATE_NEW_PAYMENT: `${PRODUCT_BASE}/seller/payment/create`,
    UPDATE_PAYMENT_STATUS: `${PRODUCT_BASE}/payment/seller/updatePaymentStatus`,
    EDIT_SELLER: `${PRODUCT_BASE}/seller/admin/updateSellerDetails`,
    PAYMENT_HISTORY: `${AUTH_BASE}/payment/seller/listSellerPaymentDetails`,
    CHECK_SELLER_ID: `${PRODUCT_BASE}/seller/admin/checkSellerId`,
  },
};
